import React, { useState, useEffect } from "react";
import SocialNetworkLinks from "../social-network-links/SocialNetworkLinks";

const ComingSoon = () => {
  const calculateTimeLeft = () => {
    const targetDate = new Date("2025-04-11T00:00:00").getTime(); // Replace with your date
    const now = new Date().getTime();
    const difference = targetDate - now;

    if (difference <= 0) return {};

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / (1000 * 60)) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen max-w-[90%] mx-auto">
      <div className="text-center bg-white p-8 rounded-lg shadow-lg max-w-md">
        <h1 className="text-3xl font-bold text-gray-800 mb-4">Coming Soon</h1>
        <p className="text-gray-600 mb-6">
          We're working hard to launch something amazing. Stay tuned!
        </p>
        {Object.keys(timeLeft).length > 0 ? (
          <div className="flex justify-center space-x-4 text-gray-800">
            {Object.entries(timeLeft).map(([unit, value]) => (
              <div key={unit} className="text-center">
                <div className="text-2xl font-semibold">{value}</div>
                <div className="text-sm uppercase">{unit}</div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-lg font-semibold text-baseGreen mt-4">
            We're live now!
          </p>
        )}
        <div className="mt-8 flex justify-center gap-4">
          <div className="text-lightBlue text-sm">Follow us for updates ➔</div>
          <SocialNetworkLinks />
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
